import type { ApiPrize } from '../../shared/types';
import { api, get, patch, post, remove } from '../../shared/api/http';

export interface CreatePrizeInput {
  name: string;
  value: number;
  emoji?: string;
}

/** Prêmios de um sorteio, na ordem da fila. */
export const prizesApi = {
  listByEvent: (eventId: string): Promise<ApiPrize[]> => get(`/events/${eventId}/prizes`),
  create: (eventId: string, input: CreatePrizeInput): Promise<ApiPrize> => post(`/events/${eventId}/prizes`, input),
  update: (id: string, input: Partial<CreatePrizeInput>): Promise<ApiPrize> => patch(`/prizes/${id}`, input),
  reorder: (eventId: string, ids: string[]): Promise<ApiPrize[]> => api('PUT', `/events/${eventId}/prizes/order`, { ids }),
  remove: (id: string): Promise<void> => remove(`/prizes/${id}`),
};
